import {
  FABRICATORS_REQUEST, FABRICATORS_SUCCESS,
  FABRICATORS_STATUS_REQUEST, FABRICATORS_STATUS_SUCCESS,
  FABRICATORS_ALL_REQUEST, FABRICATORS_ALL_SUCCESS,
  ENTITIES_ASSIGN_SAVING, ENTITIES_ASSIGN_SAVED,
  POPUP_ASSIGN_ENTITY_SAVING, POPUP_ASSIGN_ENTITY_SAVED
} from '../../constants/actionTypes';
import * as _ from 'lodash';


import {CloningGroupNameAll, TYPES} from "./FabricatorsActions";
import {filterFeaturesByValues} from "../FeatureCreator/FeaturesFilters/filtersFunctions";

const initialState = {
  data: {
    errors: [],
    page: 0,
    pageSize: 50,
    rows: [],
    totalPages: 0
  },
  allFabricators: {},
  searchKeyword: '',
  allFabricatorsSearchKeyword: '',
  loading: false,
  statusUpdateSuccess: false,
  isCloningFeaturesBusy: false,
  cloningFabFeaturesData: null,
  cloneFabricatorInProgress: false,
  cloneFabricatorAnswer: null,
  cloningFabFeaturesGroups: {},
  cloningFabFeaturesSelectedGroup: CloningGroupNameAll,
  cloningFabFeaturesSearchTerm: ''
};

export default function fabricators(state = initialState, action) {
  switch (action.type) {
    case TYPES.CLONE_FABRICATOR_REQUEST:
      return {...state, cloneFabricatorInProgress: true};
    case TYPES.CLONE_FABRICATOR_RESPONSE:
      return {...state, cloneFabricatorInProgress: false, cloneFabricatorAnswer: action.payload};
    case TYPES.CLONE_FEATURES_RESPONSE:
      return {...state, isCloningFeaturesBusy: false, cloningFabFeaturesData: null};
    case TYPES.LOAD_CLONING_FAB_FEATURES_REQUEST:
      return {...state, isCloningFeaturesBusy: true, cloningFabFeaturesData: null};
    case TYPES.LOAD_CLONING_FAB_FEATURES_RESPONSE: {
      const {features} = action.payload;
      features.forEach(_ => _.isChecked = true);
      // const groups = __parseCloningFabFeaturesGroups(action.payload);
      const groups = action.payload.uniqueGroupNames;
       return {...state, isCloningFeaturesBusy: false, cloningFabFeaturesData: action.payload,
        cloningFabFeaturesGroups: groups};
    }
    case TYPES.SET_CLONING_FEATURES_SELECTION: {
      const features = cloningGetFeaturesFromGroup(state, state.cloningFabFeaturesSelectedGroup,
        state.cloningFabFeaturesSearchTerm, action.payload.selectedFilters);
      features.forEach(f => {
        switch (action.payload.selection) {
          case 'all': f.isChecked = true; break;
          case 'none': f.isChecked = false; break;
          case 'invert': f.isChecked = !f.isChecked; break;
        }
      });
      return {...state, cloningFabFeaturesData: _.cloneDeep(state.cloningFabFeaturesData)};
    }
    case TYPES.SET_CLONING_FEATURE_CHECKED: {
      const {featureId, checked} = action.payload;
      return {...state,
        cloningFabFeaturesData: Object.assign({}, state.cloningFabFeaturesData, {
          features: state.cloningFabFeaturesData.features.map(feature => {
            if (feature.id === featureId) {
              return Object.assign({}, feature, {isChecked: checked});
            }
            return feature
          })
        })
      };
    }
    case TYPES.SET_CLONING_FEATURE_FILTERS: {
      const {shouldUpdateFeatures, features} = action.payload;
      if (!shouldUpdateFeatures) {
        return state;
      }
      return {...state, cloningFabFeaturesData: Object.assign({}, state.cloningFabFeaturesData, {
          features
        })};
    }
    case FABRICATORS_REQUEST:
      return {
        ...state,
        searchKeyword: action.searchKeyword,
        loading: true,
        statusUpdateSuccess: false
      };
    case FABRICATORS_ALL_REQUEST:
      return {
        ...state,
        allFabricatorsSearchKeyword: action.searchKeyword
      };
    case FABRICATORS_STATUS_REQUEST:
      return {
        ...state,
        loading: false,
        statusUpdateSuccess: false
      };
    case FABRICATORS_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
        statusUpdateSuccess: false
      };
    case FABRICATORS_STATUS_SUCCESS:
      return {
        ...state,
        statusUpdateSuccess: true
      };
    case ENTITIES_ASSIGN_SAVING:
    case POPUP_ASSIGN_ENTITY_SAVING:
      return {
        ...state,
        loading: false,
        statusUpdateSuccess: false
      };
    case ENTITIES_ASSIGN_SAVED:
    case POPUP_ASSIGN_ENTITY_SAVED:
      return {
        ...state,
        statusUpdateSuccess: true
      };
    case TYPES.CLONE_FABRICATOR_CHANGE_GROUP: {
      const {newGroupName} = action.payload;
      return {...state, cloningFabFeaturesSelectedGroup: newGroupName};
    }
    case TYPES.CLONE_FABRICATOR_SET_SEARCH_TERM: {
      const {searchTerm} = action.payload;
      return {...state, cloningFabFeaturesSearchTerm: searchTerm};
    }
    case TYPES.CLONE_FABRICATOR_RESET:
      return {...state, cloningFabFeaturesSearchTerm: '', cloningFabFeaturesData: null, cloningFabFeaturesGroups: {}}
    default:
      return state;
  }
}

export function cloningGetFeaturesFromGroup(state, groupName, searchTerm, selectedFilters = []) {
  if (!state.cloningFabFeaturesData)
    return [];
  const {features} = state.cloningFabFeaturesData;
  let filteredFeatures;
  if (groupName === CloningGroupNameAll) {
    filteredFeatures = features;
  } else {
    const ids = state.cloningFabFeaturesGroups[groupName];
    filteredFeatures = _.intersectionWith(features, ids, (f, id) => f.id === id);
    if (selectedFilters.length) {
      filteredFeatures = filterFeaturesByValues(filteredFeatures, selectedFilters);
    }
  }
  if (!searchTerm || searchTerm.length === 1)
    return filteredFeatures;
  searchTerm = searchTerm.toLowerCase();
  return _.filter(filteredFeatures, f => f.featureName.toLowerCase().indexOf(searchTerm) !== -1);
}


/**
 * PRIVATE METHODS
 */

function __parseCloningFabFeaturesGroups({features}) {
  const groups = {};
  (features || []).forEach(f => {
    const {featureName, groupName} = f;
    let localGroupName = groupName;
    if (_.isEmpty(localGroupName)) {
      const parts = featureName.split(' - ');
      if (!_.isEmpty(parts) && parts.length > 1) {
        localGroupName = parts[0].trim();
      }
    }

    if (!_.isEmpty(localGroupName)) {
      if (!groups[localGroupName]) {
        groups[localGroupName] = [f.id];
      } else {
        groups[localGroupName].push(f.id);
      }
    }
  });

  return groups;
}

